import React from 'react'
import styled from 'styled-components'
import { Grid, Row } from 'react-styled-flexboxgrid-tmp'

import { HEADER_HEIGHT, BREAK_POINT_SM, BREAK_POINT_MD } from '@CSSVars/variables'
import {
  GREY_BACKGROUND,
} from '@CSSVars/colors'


export const _Grid = styled.div`
  display: -ms-grid;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
  grid-gap: 20px;
`

export const _Pagination = styled(({ fixedPosition, justifyRight, ...props }) => <Row {...props} />)`
  ${(props) => (
    props.fixedPosition ?
      `
        width: 100%;
        padding: 20px 0;
        position: relative;
        margin: 0;
        border-top: 1px solid white;
        background-color: ${GREY_BACKGROUND};
        z-index: 100;
      ` : ''
  )}

  ${(props) => (
    props.fixedPosition && props.justifyRight ?
      `
        justify-content: flex-end;
        background: transparent;
      ` : ''
  )}

  ${(props) => (
    props.justifyRight ?
      `
        @media screen and (max-width: ${BREAK_POINT_MD}) {
          padding-right: 16px;
        }
      ` : ''
  )}
`

export const _PaginatedList = styled(({ fixedPosition, ...props }) => <Grid {...props} />)`
  padding: 0;

  ${(props) => (
    props.fixedPosition ?
      `
        display: block;
        padding: 0;
        overflow: hidden;
        max-width: 100%;
        min-height: calc( 100vh - 190px - ${HEADER_HEIGHT} );


        ${_Pagination} {
          @media screen and (max-width: ${BREAK_POINT_SM}) {
            padding: 20px 0;
          }
        }
      ` : ''
  )}
`

export const _ListWrapper = styled.div`
  ${({ fixedPosition }) => (
    fixedPosition ?
      `
        min-height: 0;
        overflow-y: hidden;

        /*To Keep the momentum effect for scrolling on mobile */
        -webkit-overflow-scrolling: touch;
      ` : ''
  )}
`


export const _List = styled(({ fixedPosition, isSmallList, ...props }) => <Row {...props} />)`
  ${(props) => (
    props.fixedPosition ?
      `
        margin: 0;
        padding: 1rem 0.5rem 0;
        width: 100%;
        overflow: hidden;

        min-height: ${props.isSmallList ? `calc( 100vh - 190px - ${HEADER_HEIGHT} )` : 'auto'};

        ${_Pagination} {
          height: ${props.isSmallList ? '80px' : '40px'};
          position: relative;
        }
      ` : ''
  )}
`
